module.exports = __webpack_public_path__ + "static/googleIcon-fedfa7a287a894feb8aa1ac32ad8955f.jpg";